let endpoints_SensitiveData_DEV_Develop = {
	SaveUserCPRADetails: {
		url_NA: "https://us1.api.kimclark.com/kcc-sls-ang-kcpuser-pxy-api-supdev/na/v2/UserService/SaveUserCPRADetails",
		method: "POST"
	}
}

export { endpoints_SensitiveData_DEV_Develop };